/**
 * Map a playback position in milliseconds to the index of the currently-spoken
 * word inside a TTS chunk's `alignment_timestamps` array.
 *
 * Returns -1 if `positionMs` is before the first word or the array is empty.
 *
 * The timestamps are `TtsDetail.alignment_timestamps` as the contract decodes
 * them — see `TtsTimestampMs` in api-contract/schemas/tts-dtos.ts.
 */

import type { TtsTimestampMs } from '@listening/api-contract/schemas';

export function findActiveWordIdx(
  alignment: ReadonlyArray<TtsTimestampMs>,
  positionMs: number,
): number {
  const first = alignment[0];
  if (!first) return -1;
  if (positionMs < first.start) return -1;

  // Binary search for the largest start <= positionMs.
  let lo = 0;
  let hi = alignment.length - 1;
  while (lo < hi) {
    const mid = Math.floor((lo + hi + 1) / 2);
    const midEntry = alignment[mid];
    if (midEntry && midEntry.start <= positionMs) lo = mid;
    else hi = mid - 1;
  }
  return lo;
}
